type MetaProps = {
  fulfillmentMode?: string | null;
  pinnedStoreCity?: string | null;
  pinnedStoreName?: string | null;
  pinnedStoreState?: string | null;
  reservationMode?: string | null;
};

export function createMetaVariables(
  metaProps: MetaProps = {},
  additionalProps = {}
) {
  return {
    storeCity: metaProps.pinnedStoreCity ?? '',
    storeFulfillment: metaProps.fulfillmentMode ?? '',
    storeName: metaProps.pinnedStoreName ?? '',
    storeStateAbbr: metaProps.pinnedStoreState ?? '',
    storeType: metaProps.reservationMode ?? '',
    ...additionalProps,
  };
}
